import { Card } from "@mantine/core";
import { useOutletContext } from "react-router-dom";
import TableColaboradores from "@/modules/relatorio/components/table-colaboradores";
import { TRelatorioContext } from "../RelatorioLayout";

const ColaboradoresTab = () => {
  const { values } = useOutletContext<TRelatorioContext>();

  return (
    <Card>
      <TableColaboradores questionario={values?.questionario} />
    </Card>
  );
};

export default ColaboradoresTab;
